import "./portfolio.css";
import { useNavigate } from "react-router-dom";

export default function Portfolio() {
  const navigate = useNavigate();
  return (
    <div className="portfolio-page">
      <header>
        <div className="logo">Nguyễn Ngọc Gia Hân</div>

        <nav>
          <a href="#experience">Kinh Nghiệm</a>
          <a href="#skills">Năng Khiếu</a>
          <a href="#contact">Thông Tin Liên Lạc</a>
        </nav>
      </header>

      <section className="hero">
        <div className="photo-panel">
      
        </div>

        <div className="hero-content">
          <div className="kicker">Communications Portfolio</div>

          <h1>
            Hello, Mình tên là <span>Gia Hân</span>
          </h1>

          <div className="kicker">Mục tiêu dài hạn của mình:</div>

          <p>
            Được phụ trách những công việc, nhiệm vụ quan trọng trong quá trình
            tổ chức sự kiện.
          </p>

          <div className="hero-buttons">
            <button
  type="button"
  className="btn-dark"
  onClick={() => navigate("/blog_section")}
>
  View my Blogs
</button>
           
          </div>
        </div>
      </section>

    <section id="experience" className="experience">
  <div className="exp-heading">
    <span>Portfolio Journey</span>
    <h1>Experience Timeline</h1>
  </div>

  <div className="timeline">
    <div className="item">
      <div className="card">
        <span className="year">Podcast</span>
        <h2>Cộng tác viên tại Bo&Ali</h2>
        <p>Lên ý tưởng nội dung và lồng tiếng cho podcast.</p>
      </div>
      <div className="dot"></div>
    </div>

    <div className="item">
      <div className="dot"></div>
      <div className="card">
        <span className="year">MC</span>
        <h2>MC Cho đoàn trường THPT</h2>
        <p>
          Dẫn chương trình cho các sự kiện học đường, rèn luyện khả năng nói
          trước đám đông và xử lý tình huống trên sân khấu.
        </p>
      </div>
    </div>

    <div className="item">
      <div className="card">
        <span className="year">Founder</span>
        <h2>Founder group Giao Lộ Niên Hoa</h2>
        <p>Lên ý tưởng nội dung và quản lý hoạt động cộng đồng.</p>
      </div>
      <div className="dot"></div>
    </div>

    <div className="item">
      <div className="dot"></div>
      <div className="card">
        <span className="year">Event</span>
        <h2>BTC cuộc thi “Nét đẹp nơi sân trường”</h2>
        <p>
          Tham gia xây dựng và triển khai kế hoạch tổ chức cuộc thi trực tuyến,
          quản lý thông tin thí sinh, tiếp nhận đăng ký và giải đáp thắc mắc.
        </p>
      </div>
    </div>

    <div className="item">
      <div className="card">
        <span className="year">Sales</span>
        <h2>Nhân viên bán hàng Part time</h2>
        <p>
          Hỗ trợ truyền thông, kết nối đối tác, phối hợp tổ chức hoạt động CLB
          và take care nhà tài trợ, nghệ sĩ.
        </p>
      </div>
      <div className="dot"></div>
    </div>

    <div className="item">
      <div className="dot"></div>
      <div className="card">
        <span className="year">Program</span>
        <h2>Cộng tác viên cuộc thi “Tỏa sáng thiên thần nhí - mùa 6”</h2>
        <p>
          Hỗ trợ tổ chức chương trình, take care thí sinh và phối hợp cùng đội
          hậu cần, truyền thông.
        </p>
      </div>
    </div>

    <div className="item">
      <div className="card">
        <span className="year">External Relations</span>
        <h2>Thành viên CLB Truyền thông C&C</h2>
        <p>
          Tham gia ban đối ngoại, tư vấn và chăm sóc khách hàng, rèn luyện kỹ
          năng giao tiếp và nắm bắt tâm lý khách hàng.
        </p>
      </div>
      <div className="dot"></div>
    </div>
  </div>
</section>

  <section id="skills" className="skills-showcase">
  
   

   

  <div className="skills-right">
 <span className = "skill_span">KỸ NĂNG</span>
    {[
 {
        number: "01",
        title: "Giao tiếp và tạo lập mối quan hệ",
        icon: "https://res.cloudinary.com/dmyyrftce/image/upload/c_thumb,w_200,g_face/v1783053899/giaotiep_zsaaei.png",
      },
      {
        number: "02",
        title: "Nắm bắt tâm lý khán giả / đối tác",
        icon: "https://res.cloudinary.com/dmyyrftce/image/upload/c_thumb,w_200,g_face/v1783053899/nambat_ge3wd7.png",
      },
      {
        number: "03",
        title: "Quản lý thời gian",
        icon: "https://res.cloudinary.com/dmyyrftce/image/upload/c_thumb,w_200,g_face/v1783053922/thoigian_rvhlye.png",
      },
      {
        number: "04",
        title: "Lập kế hoạch",
        icon: "https://res.cloudinary.com/dmyyrftce/image/upload/c_thumb,w_200,g_face/v1783053899/kehoach_cww0ww.png",
      },
      {
        number: "05",
        title: "Thiết kế (Canva, CapCut)",
        icon: "https://res.cloudinary.com/dmyyrftce/image/upload/c_thumb,w_200,g_face/v1783053923/thietke_nniris.png",
      },
      {
        number: "06",
        title: "Tin học văn phòng",
        icon: "https://res.cloudinary.com/dmyyrftce/image/upload/c_thumb,w_200,g_face/v1783054371/vanphong_pedu5u.png",
      },
      {
        number: "07",
        title: "Làm việc nhóm và làm việc độc lập",
        icon: "https://res.cloudinary.com/dmyyrftce/image/upload/c_thumb,w_200,g_face/v1783054390/doclap_rcpwpb.png",
      },
      {
        number: "08",
        title: "MOS Word & Excel",
        icon: "https://res.cloudinary.com/dmyyrftce/image/upload/c_thumb,w_200,g_face/v1783054389/chungchi_u5d2xr.png",
      },
    ].map((skill) => (
      <div className="skill-row" data-number={skill.number} key={skill.number}>
        <div className="skill-text">
        <img src={skill.icon} alt="" className="skill-icon" />
          <h3>{skill.title}</h3>
    
        </div>

        <div className="line"></div>

        <div className="number">{skill.number}</div>
      </div>
    ))}
  </div>
</section>

     <section id="contact" className="contact">
  <div className="contact-scene">
    <div className="contact-title">
      <span>Thông Tin Liên Lạc</span>
      <h2>Và Thông Tin Cá Nhân </h2>
      <p>
    
      </p>
    </div>

    <div className="phone">
      <div className="phone-screen">
        <div className="phone-top">
          <div className="avatar">GH</div>
          <div>
            <strong>Nguyễn Ngọc Gia Hân</strong>
            <small>Available to connect</small>
          </div>
        </div>

        <div className="chat">
          <div className="bubble left">
            Bạn sinh năm mấy?
          </div>
          <div className="bubble right">
            Mình sinh năm 2007
          </div>
          <div className="bubble left">
           mình muốn biết thêm về thông tin học vấn của bạn
          </div>
          <div className="bubble right">
           mình học tại Trường Đại học Văn Hóa TP.HCM, Sinh viên năm nhất chuyên ngành Truyền thông văn hóa
          </div>

       <div className="bubble left">
            Ok,  vậy mình liên lạc với bạn bằng cách nào?
          </div>
        </div>

        <div className="contact-buttons">
          <a className="contact-btn" href="mailto:giahan@example.com">
            📧Email: hann09092007@gmail.com
          </a>
        </div>
      </div>
    </div>
  </div>
</section>
<footer>© 2026 Nguyễn Ngọc Gia Hân — Communications Portfolio</footer>
    </div>
  );
}